/*
FORK of assets/skio-plan-picker-component--v2.js for the Deep Zzzs OFFER page
(templates/page.LP-Deep-Zzzs-Offer.json). Loaded ONLY by
snippets/product-info--v2--deep-zzzs-offer.liquid; the live Deep Zzzs PDP keeps
loading the original file. Same custom-element tag (skio-plan-picker-v2) so the
existing selectors, the dz-offer-formula-script listeners and the section's
discount auto-apply script keep working unchanged.

Adds DISPLAY-ONLY welcome-offer pricing. The money is applied by the Shopify
discount codes the section's auto-apply script sends (/discount/CODE); there is
no Skio selling-plan change and properties[Discount] is untouched.

  offer-onetime-percent  Number  % off the LIST price for Try Once (0 = off)
  offer-sub-percent      Number  % off the SUBSCRIPTION PLAN price, first order
                                 only (0 = off). 20% on a $45 plan = $36 = 40% off list.
  offer-onetime-tag      String  small tag under the Try Once price, e.g. "Welcome · 30% off"
  offer-sub-badge        String  template, {pct} = effective % off list, default "{pct}% OFF FIRST ORDER"
  offer-sub-then         String  template, {price} = recurring plan price, {pct} = plan
                                 discount, default "Then {price}/mo ({pct}% off, for life) · pause, skip or cancel anytime"

All prices are computed in integer cents (Math.round) and displayed WITH cents
("$36.00"). The computed prices are exposed on the host element as
data-dz-offer-once-cents / data-dz-offer-sub-cents and in the
skio::update-selling-plan event detail (offerOnceCents / offerSubCents).
With both percents absent or 0 the behaviour is identical to the original.

--- original header follows ---

Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker 
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      currency='{{ cart.currency.iso_code }}'
      useVariantInputClickEvents='false'
      variantInputSelector=''
      >
    </skio-plan-picker>
    <input type="hidden" aria-hidden="true" name="selling_plan" value="">
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
  .product-info__price {
      display: none;
  }
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    border: 0;
    max-width: 100%;
    color: #000;
  }
  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    box-shadow: 0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.07);
    border-radius: 20px;
    border-width: 2px;
    border-color: #979797;
    border-style: solid; 
    transition: border-color 0.2s ease, background-color 0.2s ease;
    background-color: #fff;
  }
  .skio-group-container--selected {
    border-color: #4E7CBB;
  }
  
  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px solid var(--mgc-deep);
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 20px;
    overflow: hidden;
  }
  
  .skio-group-topline {
    display: flex;
    /* justify-content: space-between; */
    /* flex-wrap: wrap; */
    align-items: start;
    width: 100%;
    font-size: 16px;
  }
  
  .skio-radio__container {
    display: flex;
    margin-right: 10px;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    /* margin-left: auto; */
    color: #000000;
    font-size: 27px;
    display: flex;
    align-items: center;
  }

  [skio-onetime-price] {
    margin-left: 10px;
    font-size: 24.62px;
  }

  .skio-price del {
    color: #7D7D7D;
    margin-right: 10px;
  }
  
  .skio-group-content {
    width: 100%;
    border-top: 1px solid rgba(0, 0, 0, 0.43);
    margin-top: 15px;
    /* margin-left: 30px; */
    /* transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    max-height: 38px;
    opacity: 1; */
  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    /* max-height: 0;
    opacity: 0;
    pointer-events: none; */
  }
  
  .skio-group-title {
    min-width: max-content;
    font-size: 19.2px;
    padding-bottom: 0px;
    text-transform: uppercase;
    color: #000;
    transition: color 0.2s ease;
    font-weight: bold;
  }

  .skio-group-container--selected .skio-group-title {
    color: #273166;
  }
  
  .skio-save {
    color: #fff;
    padding: 0px 8px;
    border-radius: 9.6px;
    background-color: #86CCD8;
    font-size: 13px;
    margin-left: 14px;
    min-height: 29px;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
  }
  
  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 13px 15px;
    text-align: center;
    border-radius: 120px;
    color: rgb(255, 255, 255);
    background-color: rgb(32, 73, 143);
    width: 100%;
    border: 0px;
    font-size: 14px;
    font-family: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='white' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    min-width: 150px;
    min-height: auto;
    margin-left: auto;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
    pointer-events: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  button.add-to-cart {
    justify-content: center;
    font-weight: 400;
    text-transform: capitalize;
    letter-spacing: 0;
    font-style: normal;
    font-size: 16px;
    text-decoration: none;
    box-shadow: 0 0 #0000004d inset;
    width: 100%;
    color: #fff;
    background-color: #000;
    border-radius: 5px;
    transition-duration: .3s;
    padding: 10px 32px;
    text-transform: uppercase;
    cursor: pointer;
    font-family: 'FK Grotesk Neue Trial';
    transition: border-color 0.25s ease, background-color 0.25s ease, color 0.25s ease;

    border: solid 2px rgba(0,0,0,0);
  }
  button.add-to-cart:hover {
    background-color: rgba(0,0,0,0);
    color: #000;
    border-color: #000;
  }

  .skio-details {
    --text-color: #333;
    --text-color-secondary: #888; 
    
    user-select: none;
    -webkit-user-select: none;
    margin-bottom: 20px;
    order: 3;
    max-width: max-content;
  }

  .skio-details summary::-webkit-details-marker,
  .skio-details summary::marker,
  .skio-details slot {
    color: rgba(0,0,0,0) !important;
  }

  .skio-details summary {
    margin-top: 15px;
  }

  .skio-details summary span {
    font-size: 0.9em;
    display: flex;
    padding: .5em 0;
    cursor: pointer;
    align-items: center;
    gap: 10px;
    text-decoration: underline;

    margin-top: -40px;
    color: #000;
  }

  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translateY(-15px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .skio-details[open] > .skio-details--content {
    animation-name: fadeInDown;
    animation-duration: 0.3s;
  }

  .skio-details--content {
    position: absolute;
    z-index: 1020;
    padding: 1em;
    width: fit-content;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
  }

  .skio-details ul {
    margin: 0;
    padding: 0;
  }

  .skio-details ul li {
    display: flex;
    align-items: flex-start;
    gap: .75em;

    margin-bottom: 1em;
  }

  .skio-details .skio-content {
    display: flex;
    flex-direction: column;
  }

  .skio-details .skio-content p {
    font-size: 0.9em;

    margin-top: 0;
    margin-bottom: 0;

    letter-spacing: 0;
    line-height: 1.5;

    color: var(--text-color);
  }

  .skio-details ul li small {
    font-size: 0.7em;
    color: var(--text-color-secondary);
  }

  .skio-details .skio-icon {
    display: flex;

    width: 2.25em;
    height: 2.25em;

    color: var(--text-color);
    background: #f8f8f8;
    border-radius: 100%;

    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  .skio-details .skio-icon svg {
    width: 1.25em;
    height: 1.25em;

    color: inherit;
  }

  .skio-details--footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9em;
  }

  .skio-details--footer a {
    color: var(--text-color);
  }

  .skio-manage-link {
    text-decoration: underline;
  }

  .powered-by-skio {
    font-size: 0.8em;

    display: flex;
    text-decoration: none;
    
    align-items: center;
    gap: 3px;
  }

  .trialCopy {
    font-size: 12px;
    padding: 10px 0px;
  }

  .skio-group-content ul {
    list-style: none;
    margin-left: 0;
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
  }

  .skio-group-content ul li {
    list-style: none;
    flex: 0 0 50%;
    margin-bottom: 10px;
    font-size: 16px;
    color: #000;
  }

  .skio-group-content ul li svg {
    margin-right: 5px;
  }

  .skio-group-right {
    margin-left: auto;
    text-align: center;
  }

  .skio-group-left.skio-group-left-onetime {
    display: flex;
    flex-direction: column;
  }

  .skio-group-left.skio-group-left-onetime .flex {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }

  .price-per-serving {
    font-style: italic;
    padding-top: 10px;
    font-size: 16px;
    color: #505050;
    display: block;
  }

  .skio-group-container--selected.blue-background {
    background-color: #F2F4FF;
    border-color: #20498F;
  }
  .skio-group-container--selected .skio-group-title.blue-text {
    color: #273166;
  }
  .blue-save {
    background-color: #86CCD8
  }
  .blue-dropdown {
    background-color: #20498F;
  }

  .skio-group-container--selected.red-background {
    background-color: #FFF4D7;
    border-color: #E7670C;
  }
  .skio-group-container--selected .skio-group-title.red-text {
    color: #CB5231;
  }
  .red-save {
    background-color: #CC411D
  }
  .red-dropdown {
    background-color: #CC411D;
  }

  .skio-group-container--selected.green-background {
    background-color: #F3FFE0;
    border-color: #087363;
  }
  .skio-group-container--selected .skio-group-title.green-text {
    color: #174E45;
  }
  .green-save {
    background-color: #183F3A
  }
  .green-dropdown {
    background-color: #087363;
  }
  .skio-group-topline .skio-group-left{padding: 0 0 0 47px}

  .skio-group-container--available label::before {
    content: "";
    position: absolute;
    left: 15px;
    right: auto;
    margin: 0px auto;
    top: 35px;
    width: 32px;
    height: 31px;
    background-color: rgb(255, 255, 255);
    border: 1.5px solid rgb(151, 151, 151);
    border-radius: 50%;
    z-index: 1;
  }
  .skio-group-container--available input[type="radio"] + label::after {
    position: absolute;
    content: "";
    left: 20px;
    top: 40px;
    width: 22px;
    height: 22px;
    border: 1.5px solid transparent;
    z-index: 1;
    opacity: 1;
    border-radius: 50%;
  }

  .skio-group-container--available input[type="radio"]:checked+label::after {  
    background: #20498F;
  }
   .skio-group-container--available input[type="radio"]:checked + label::before {	
    border: 1.5px solid #20498F;
  }

  .red-background input[type="radio"]:checked+label::after {  
    background: #E7670C;
  }
  .red-background input[type="radio"]:checked + label::before {	
    border: 1.5px solid #E7670C;
  }

  .blue-background input[type="radio"]:checked+label::after {  
    background: #20498F;
  }
  .blue-background input[type="radio"]:checked + label::before {	
    border: 1.5px solid #20498F;
  }

  .green-background input[type="radio"]:checked+label::after {  
    background: #087363;
  }
  .green-background input[type="radio"]:checked + label::before {	
    border: 1.5px solid #087363;
  }

/***********/
.skio-group-container--selected.mood-background {
    background-color: #FAEDFF;
    border-color: #8958E5;
  }
  .skio-group-container--selected .skio-group-title.mood-text {
    color: #8958E5;
  }
  .mood-save {
    background-color: #D992EF
  }
  .mood-dropdown {
    background-color: #8958E5;
  }
   .mood-background input[type="radio"]:checked+label::after {  
    background: #8958E5;
  }
  .mood-background input[type="radio"]:checked + label::before {	
    border: 1.5px solid #8958E5;
  }

  @media only screen and ( max-width:767px ){
    .skio-group-label {      
      padding: 10px;      
    }
    .skio-group-topline {
      flex-wrap: wrap;
    }
    .skio-group-right {     
      margin: 5px 0px 0px;
    } 
    .skio-group-left.skio-group-left-onetime {
      width: 100%;
    }   
    .price-per-serving {
      padding-top: 0px;
    }
    .skio-group-container--available label::before {      
      left: 10px;     
      top: 30px;
      width: 32px;
      height: 31px;
    }
    .skio-group-container--available input[type="radio"] + label::after {      
      left: 15px;
      top: 34px;
      width: 22px;
      height: 22px;
    }
  } 
  
  @media only screen and ( max-width:600px ){
    .skio-group-content ul li {      
      flex: 0 0 100%;
    }
  }

  /* ===== V2 Buy Box (spec v9) — colors come from mgc-pdp.css :root tokens ===== */
  .skio-plan-picker { gap: 18px; }

  .skio-v2-group,
  .skio-v2-onetime,
  .skio-v2-ctalinks { font-family: var(--mgc-font-body); }

  /* Subscribe card. State grammar (2026-07, applies to every card in the buy
     box): WHITE surface = selected, --mgc-bb-idle-bg = idle. Previously this
     card stayed white while INACTIVE, which false-signaled "chosen" next to
     a selected Try Once — inverted so lightness always tracks selection. */
  .skio-v2-group.skio-group-container {
    border: 1px solid var(--mgc-bb-onetime-border);
    border-radius: 16px;
    padding: 24px;
    background: var(--mgc-bb-idle-bg) !important;
    box-shadow: none !important;
    margin: 0;
  }
  .skio-v2-group.skio-group-container--selected {
    border: 3px solid var(--mgc-deep) !important;
    padding: 22px;
    background: var(--mgc-bb-card-bg) !important;
  }
  .skio-v2-group.skio-group-container label::before,
  .skio-v2-group.skio-group-container input[type="radio"] + label::after { display: none !important; }
  .skio-v2-group .skio-group-label {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }

  /* Header: radio + title left, price right */
  .skio-v2-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  .skio-v2-titlewrap { display: flex; align-items: center; gap: 11px; min-width: 0; }
  .skio-v2-radio {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid var(--mgc-deep);
    background: var(--mgc-bb-card-bg);
    flex: 0 0 auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .skio-v2-radio::after {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: var(--mgc-deep);
    transform: scale(0);
    transition: transform 0.18s cubic-bezier(0.22, 1, 0.36, 1);
  }
  .skio-group-input:checked + label .skio-v2-radio::after { transform: scale(1); }
  .skio-v2-group .skio-v2-title {
    font-family: var(--mgc-font-body) !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    line-height: 1.15 !important;
    color: var(--mgc-heading-ink) !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    margin: 0 !important;
    min-width: 0 !important;
  }
  .skio-v2-price { text-align: right; flex: 0 0 auto; display: flex; align-items: baseline; gap: 6px; }
  /* Compare-at strike price sized up (17px/400 -> 21px/600, per Alec 2026-07)
     so the discount reads at a glance — shared component, applies to every
     PDP using this buy box (Deep Zzzs, Magnesium, ...). Color stays the muted
     --mgc-bb-strike so the live price keeps the visual priority. */
  .skio-v2-price del {
    font-size: 21px;
    font-weight: 600;
    color: var(--mgc-bb-strike);
    text-decoration: line-through;
  }
  .skio-v2-price [skio-subscription-price] {
    font-family: var(--mgc-font-body) !important;
    font-size: 26px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    color: var(--mgc-deep) !important;
  }

  /* Tags row */
  .skio-v2-tags { display: flex; align-items: center; gap: 8px; margin-top: 10px; flex-wrap: wrap; }
  .skio-v2-tag-best {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: var(--mgc-bb-best-bg);
    color: var(--mgc-indigo);
    font-size: 12px;
    font-weight: 600;
    padding: 4px 9px;
    border-radius: 19px;
  }
  .skio-v2-tag-best svg { color: var(--mgc-indigo); flex: 0 0 auto; }
  .skio-v2-tag-save {
    background: var(--mgc-periwinkle);
    color: var(--mgc-deep);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .3px;
    text-transform: uppercase;
    padding: 3px 9px;
    border-radius: 19px;
    white-space: nowrap;
  }

  /* Per-night hero + savings line */
  .skio-v2-hero {
    font-size: 19px;
    font-weight: 600;
    color: var(--mgc-deep);
    line-height: 1.15;
    margin-top: 16px;
  }
  .skio-v2-savings { font-size: 15px; line-height: 1.35; margin-top: 4px; }
  .skio-v2-savings .s1 { color: var(--mgc-save); font-weight: 500; }
  .skio-v2-savings .s2 { color: var(--mgc-save-strong); font-weight: 600; }
  .skio-v2-savings .s3 { color: var(--mgc-bb-savings-paren); }

  /* Trust strip */

  /* Divider (only one) */
  .skio-v2-divider { height: 1px; background: var(--mgc-bb-divider); margin: 20px 0 18px; width: 100%; }

  /* Frequency label + native select chrome */
  .skio-v2-freq-label { font-size: 16px; font-weight: 600; color: var(--mgc-deep); margin-bottom: 9px; }
  .skio-v2-freq-field { position: relative; }
  .skio-v2-group select.skio-v2-select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    max-width: 100%;
    height: 52px;
    margin: 0;
    border: 1px solid var(--mgc-deep);
    border-radius: 10px;
    padding: 0 46px 0 15px;
    font-family: var(--mgc-font-body);
    font-size: 18px;
    font-weight: 600;
    color: var(--mgc-body);
    background: var(--mgc-bb-card-bg);
    cursor: pointer;
    text-align: left;
    text-transform: none;
    box-shadow: none;
  }
  .skio-v2-chevron {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: var(--mgc-deep);
  }

  /* Benefits: 2-col desktop / 1-col mobile */
  .skio-v2-benefits { margin-top: 18px; }
  .skio-v2-benefits ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px 22px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .skio-v2-benefits li {
    display: flex;
    align-items: center;
    gap: 11px;
    margin: 0;
    padding: 0;
    font-size: 15px;
    font-weight: 500;
    color: var(--mgc-indigo);
    line-height: 1.25;
  }
  .skio-v2-bicon { color: var(--mgc-deep); flex: 0 0 auto; }

  /* Free shipping callout */
  .skio-v2-ship {
    display: flex;
    align-items: center;
    gap: 11px;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid var(--mgc-bb-hairline);
  }
  .skio-v2-ship svg { color: var(--mgc-blue); flex: 0 0 auto; }
  .skio-v2-ship span { font-size: 15px; font-weight: 500; color: var(--mgc-indigo); line-height: 1.35; }
  .skio-v2-ship b { color: var(--mgc-save-strong); font-weight: 600; }
  /* mobile: the $5.95 clause takes its own line under the bold absolute (Alec)
     instead of wrapping mid-phrase ("Save $5.95 on / every order") */
  @media only screen and ( max-width:767px ){
    .skio-v2-ship-amt { display: block; }
  }

  /* CTA links between cards */
  .skio-v2-ctalinks {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 0 2px;
    order: 1;
  }
  /* With the quiz link hidden, right-align the lone "How Subscriptions Work?"
     link so it mirrors the right-aligned "Compare Formulas" up in Step 1. */
  :host([hide-quiz-link]) .skio-v2-ctalinks { justify-content: flex-end; }
  .skio-v2-ctalinks a {
    font-size: 15px;
    font-weight: 600;
    color: var(--mgc-link);
    text-decoration: underline;
    text-underline-offset: 3px;
    white-space: nowrap;
    cursor: pointer;
  }

  /* Try Once card. Same grammar: previously it KEPT the idle gray while
     selected (the chosen option wearing the unselected costume) — now it gets
     the white selected surface like every other chosen card. */
  .skio-v2-onetime.skio-group-container {
    border: 1px solid var(--mgc-bb-onetime-border);
    border-radius: 16px;
    padding: 15px 18px;
    background: var(--mgc-bb-onetime-bg) !important;
    box-shadow: none !important;
    margin: 0;
    /* Match the Deep Zzzs collapsed formula-card height (93px measured live
       with the idle hairline padding; ~80px on mobile — see the <=430 block)
       so the buy box's option cards read as one even, tidy system — Try Once
       previously sat visibly shorter than the variant selectors above it.
       Flex centering keeps the content vertically balanced inside the taller
       box; min-height is border-box so the selected 3px border changes nothing. */
    min-height: 93px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .skio-v2-onetime.skio-group-container--selected {
    border: 3px solid var(--mgc-deep) !important;
    padding: 13px 16px;
    background: var(--mgc-bb-card-bg) !important;
  }
  .skio-v2-onetime.skio-group-container label::before,
  .skio-v2-onetime.skio-group-container input[type="radio"] + label::after { display: none !important; }
  .skio-v2-onetime .skio-group-label {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 11px;
    padding: 0;
    margin: 0;
    cursor: pointer;
    width: 100%;
  }
  .skio-v2-onetime .skio-v2-radio { width: 22px; height: 22px; margin-top: 3px; }
  .skio-v2-ot-col { flex: 1; min-width: 0; }
  .skio-v2-ot-top { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; }
  /* Title/sub sized for PARITY with the Subscribe card (same 20/22/19 title
     scale) — a visually smaller Try Once reads as a lesser option. */
  .skio-v2-onetime .skio-v2-ot-title {
    font-family: var(--mgc-font-body) !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    color: var(--mgc-heading-ink) !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    margin: 0 !important;
    min-width: 0 !important;
  }
  .skio-v2-ot-price {
    font-family: var(--mgc-font-body) !important;
    font-size: 24px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    color: var(--mgc-deep) !important;
    flex: 0 0 auto;
  }
  .skio-v2-ot-price [skio-onetime-price] { color: var(--mgc-deep) !important; }
  .skio-v2-ot-sub { font-size: 16.5px; color: var(--mgc-body); margin-top: 3px; line-height: 1.4; }
  .skio-v2-ot-sub .a { font-weight: 600; color: var(--mgc-deep); white-space: nowrap; }
  .skio-v2-ot-sub .b { white-space: nowrap; }
  /* desktop separator (droppable on mobile so a wrapped .b doesn't orphan a
     trailing middot after "a night" — Alec) */
  .skio-v2-ot-sub .a + .b::before { content: " · "; }

  /* ===== Offer page (fork) — only rendered when offer-* percents are > 0 ===== */
  /* Try Once: strike + offer price stacked over a small tag, right-aligned */
  .skio-v2-ot-pricecol { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; flex: 0 0 auto; }
  .skio-v2-ot-price del {
    font-size: 19px;
    font-weight: 600;
    color: var(--mgc-bb-strike);
    text-decoration: line-through;
    margin-right: 6px;
  }
  .skio-v2-ot-offer-tag {
    font-size: 11.5px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: .02em;
    text-transform: uppercase;
    color: var(--mgc-bb-trust-text, #56526b);
    white-space: nowrap;
  }
  /* Subscribe: first-order badge is solid save-green so it reads as the offer,
     not the recurring plan discount (that lives in the "Then …" perk line). */
  .skio-v2-tag-offer { background: var(--mgc-save-strong, #146b45); color: #fff; }
  /* "You save $24.00 today · $180 a year after" — the middot is neutral ink */
  .skio-v2-savings .s-sep { color: var(--mgc-body); font-weight: 500; }

  /* Responsive: mobile <430px */
  @media only screen and ( max-width:430px ){
    .skio-v2-group.skio-group-container { padding: 20px; }
    .skio-v2-group.skio-group-container--selected { padding: 18px; }
    .skio-v2-group .skio-v2-title { font-size: 19px !important; }
    .skio-v2-price [skio-subscription-price] { font-size: 24px !important; }
    .skio-v2-price del { font-size: 19px; } /* keeps the strike/live ratio at the mobile price size */
    .skio-v2-benefits ul { grid-template-columns: 1fr; gap: 12px; }
    .skio-v2-ctalinks { flex-direction: column; align-items: flex-start; gap: 12px; }
    :host([hide-quiz-link]) .skio-v2-ctalinks { align-items: flex-end; }
    .skio-v2-ctalinks a { white-space: normal; font-size: 14px; }
    .skio-v2-onetime.skio-group-container { padding: 15px 16px; min-height: 80px; }
    .skio-v2-onetime.skio-group-container--selected { padding: 13px 14px; }
    .skio-v2-ot-price { font-size: 22px !important; }
    .skio-v2-ot-price del { font-size: 18px; } /* offer fork: keeps the strike/live ratio at the mobile Try Once size */
    .skio-v2-onetime .skio-v2-ot-title { font-size: 19px !important; } /* parity with subscribe title (19px mobile) */
    /* 15.5px keeps "$2.00 a night · Free shipping over $75" on ONE line in the
       ~284px mobile content box (16.5px wraps it, ballooning the card to 106px
       vs the 80px formula cards); min-height 80px matches them. */
    .skio-v2-ot-sub { font-size: 15.5px; }
    .skio-v2-ot-sub .b { display: block; }
    .skio-v2-ot-sub .a + .b::before { content: none; }
  }

  /* Desktop-only type bump (mobile <=430px is intentionally left untouched) */
  @media only screen and ( min-width:431px ){
    .skio-v2-group .skio-v2-title { font-size: 22px !important; }
    .skio-v2-onetime .skio-v2-ot-title { font-size: 22px !important; } /* parity with subscribe title */
    .skio-v2-ship span { font-size: 16px; }
  }

  /* ===== Collapse behavior (spec §5.5) — presentational only, driven by
     data-sel on .skio-plan-picker which READS the selected plan. When Try Once
     is selected the Subscribe card collapses to its value hook (radio + title +
     tags + price + per-night hero + savings). The detail region collapses via
     grid-template-rows 1fr->0fr (never max-height). ===== */
  .skio-v2-head { align-items: center; }
  /* Price-only right rail — expand/collapse caret removed; card click +
     aria-expanded + collapsed hint carry the affordance. */
  .skio-v2-headright { display: flex; align-items: center; flex: 0 0 auto; }

  .skio-v2-detailwrap { display: grid; grid-template-rows: 1fr; }
  .skio-v2-detail { overflow: hidden; min-height: 0; opacity: 1; }
  .skio-v2-hint {
    display: none;
    font-size: 12.5px;
    font-weight: 600;
    color: var(--mgc-deep);
    margin-top: 10px;
    line-height: 1.35;
  }
  /* Desktop: bump collapsed helper so "Tap to choose…" reads as an obvious affordance */
  @media only screen and ( min-width:431px ){
    .skio-v2-hint { font-size: 15.5px; }
  }

  /* Collapsed state (Try Once selected) */
  .skio-plan-picker[data-sel="once"] .skio-v2-detailwrap { grid-template-rows: 0fr; }
  .skio-plan-picker[data-sel="once"] .skio-v2-detail { opacity: 0; }
  .skio-plan-picker[data-sel="once"] .skio-v2-hint { display: block; }

  /* Transitions enabled only after first paint (no animation / CLS on load) */
  .skio-plan-picker.skio-anim-ready .skio-v2-detailwrap { transition: grid-template-rows .38s ease; }
  .skio-plan-picker.skio-anim-ready .skio-v2-detail { transition: opacity .3s ease; }

  @media (prefers-reduced-motion: reduce) {
    .skio-plan-picker .skio-v2-detailwrap,
    .skio-plan-picker .skio-v2-detail { transition: none !important; }
  }
  /* ===== end V2 card ===== */


  /* .skio-group-content ul li {
    padding-left: 1em;
    text-indent: -1em;
  }

  .skio-group-content ul li:before {
    content: "";
    padding-right: 27px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='16' viewBox='0 0 22 16' fill='none'%3E%3Cpath d='M7.00231 16.0002C7.00097 16.0002 6.99964 16.0002 6.99698 16.0002C6.64098 15.9989 6.3023 15.8562 6.05297 15.6029L0.719644 10.1869C0.202311 9.66157 0.208979 8.81756 0.734313 8.30156C1.25965 7.78556 2.1023 7.79088 2.61964 8.31621L7.0103 12.7749L19.3943 0.392221C19.9156 -0.129113 20.7583 -0.129113 21.2796 0.392221C21.801 0.912221 21.801 1.75756 21.2796 2.27756L7.9463 15.6109C7.69563 15.8602 7.35564 16.0002 7.00231 16.0002Z' fill='black'/%3E%3C/svg%3E");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  } */

   
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },            //required
    productHandle: { type: String },      //optional (unless product isn't passed, then required)
    key: { type: String },                //optional, defaults to product.id; identifier for this instance of the Skio plan picker

    formId: { type: String },             //optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean },       //optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    hideQuizLink: { type: Boolean, attribute: 'hide-quiz-link' }, //optional; hides the "Take our sleep quiz" link (Deep Zzzs: quiz being refactored for the new formulas)
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String },     //optional, defaults to percent; can also pass "fixed"

    currency: { type: String },           //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String },           //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {},                   //placeholder for object

    externalPriceSelector: { type: String },      //optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String },      //optional, used to update the external price

    selectedVariant: { type: Object },    //placeholder for data
    skioSellingPlanGroups: {},            //placeholder for data
    availableSellingPlanGroups: {},       //placeholder for data
    selectedSellingPlanGroup: {},         //placeholder for data
    selectedSellingPlan: {},              //placeholder for data

    defaultFrequency: {},                 //placeholder for data

    showAddToCartButton: { type: Boolean },

    meta: {},

    useVariantInputClickEvents: { type: Boolean }, // optional, allows use of variant input click events to update skio's selectedVariant
    variantInputSelector: {},

    isTrial: { type: Boolean },

    servingPrice: { type: Number },

    servingsPerContainer: { type: Number, attribute: 'servings-per-container' }, // per-night divisor: bottle price / servings. Defaults to 30.

    elementStyle: { type: String },

    // Offer page (fork) — display-only welcome-offer pricing. See file header.
    offerOnetimePercent: { type: Number, attribute: 'offer-onetime-percent' },
    offerSubPercent: { type: Number, attribute: 'offer-sub-percent' },
    offerOnetimeTag: { type: String, attribute: 'offer-onetime-tag' },
    offerSubBadge: { type: String, attribute: 'offer-sub-badge' },
    offerSubThen: { type: String, attribute: 'offer-sub-then' },

    animReady: { state: true } // gates collapse transitions until after first paint (no CLS on load)

  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = 'onetime';

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.externalPriceSelector = '[skio-external-price]';

    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]';

    this.currency = Shopify.currency.active;
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });

    this.defaultFrequency = null;

    this.showAddToCartButton = false;

    this.meta = '';

    this.lastSellingPlanName = '';

    this.showDetailsHover = false;

    this.useVariantInputClickEvents = null;
    this.variantInputSelector = null;

    this.isTrial = false;

    this.servingPrice = 0;

    this.servingsPerContainer = 30;

    this.elementStyle = '';

    this.offerOnetimePercent = 0;
    this.offerSubPercent = 0;
    this.offerOnetimeTag = '';
    this.offerSubBadge = '{pct}% OFF FIRST ORDER';
    this.offerSubThen = 'Then {price}/mo ({pct}% off, for life) · pause, skip or cancel anytime';

    this.animReady = false;

  }

  // Enable collapse transitions only after the first paint so the default
  // (expanded) state never animates or shifts layout on initial load.
  firstUpdated() {
    requestAnimationFrame(() => requestAnimationFrame(() => { this.animReady = true; }));
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.startSubscription == true) {
      this.purchaseOption = 'subscription';
    }

    if (!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key')) {
            if (el.getAttribute('skio-key') == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }
    let skio = this;
    document.addEventListener("variantChanged", function (e) {
      //update variant id
      let variantId = e.detail.variantId;
      let variant = skio.product.variants.find(x => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: skio.currency,
    });

    if (this.meta !== '') this.meta = JSON.parse(this.meta);

    if (this.useVariantInputClickEvents) {
      document.addEventListener('load', skio.addVariantClickEventListeners)
    }

  }

  render() {
    if (!this.product || !this.selectedVariant || this.skioSellingPlanGroups.length == 0 || !this.product?.available) return;
    // Offer page (fork): Try Once welcome price in cents, or null when the offer is off.
    const offerOnce = this.offerOnceCents();
    const offerOnceOn = offerOnce !== null;
    return html`
      <fieldset class="skio-plan-picker${this.animReady ? ' skio-anim-ready' : ''}" skio-plan-picker="${this.key}" data-sel="${this.selectedSellingPlanGroup == null ? 'once' : 'subscribe'}">
        <input ${this.formId !== null ? html`form="${this.formId}"` : ''} name="selling_plan" type="hidden" value="${this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ''}" />
        <input ${this.formId !== null ? html`form="${this.formId}"` : ''} name="properties[Discount]" type="hidden" value="${this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : ''}" 
          ?disabled="${this.selectedSellingPlan == null ? true : false}" />
        
        <div class="skio-group-container skio-v2-onetime ${this.product.requires_selling_plan == false ? 'skio-group-container--available' : ''} ${this.selectedSellingPlanGroup == null ? 'skio-group-container--selected' : ''} ${this.subscriptionFirst ? 'skio-onetime-second' : ''} ${this.elementStyle !== '' && this.selectedSellingPlanGroup == null ? `${this.elementStyle}-background` : ``}" skio-group-container
          @click=${() => this.selectSellingPlanGroup(null)}
          ${this.selectedSellingPlanGroup == null && this.backgroundColor !== '' && this.borderColor !== '' ? html`style="background-color: '${this.backgroundColor}'; border-color: '${this.borderColor}';"` : ''}
          >
        
          <input id="skio-one-time-${this.key}" class="skio-group-input" name="skio-group-${this.key}" type="radio" value="" 
            skio-one-time ?checked=${this.startSubscription == false && this.product.requires_selling_plan == false ? true : false}>
          <label class="skio-group-label" for="skio-one-time-${this.key}">
            <span class="skio-v2-radio"></span>
            <div class="skio-v2-ot-col">
              <div class="skio-v2-ot-top">
                <span class="skio-group-title skio-v2-ot-title">Try Once</span>
                ${offerOnceOn ? html`
                <span class="skio-v2-ot-pricecol">
                  <span class="skio-price skio-v2-ot-price"><del>${this.money(this.selectedVariant.price)}</del><span skio-onetime-price>${this.money(offerOnce)}</span></span>
                  ${this.offerOnetimeTag ? html`<span class="skio-v2-ot-offer-tag">${this.offerOnetimeTag}</span>` : html``}
                </span>
                ` : html`<span class="skio-price skio-v2-ot-price"><span skio-onetime-price>${this.moneyFormatter.format(this.selectedVariant.price / 100).replaceAll(".00", "")}</span></span>`}
              </div>
              <div class="skio-v2-ot-sub"><span class="a">${this.money((offerOnceOn ? offerOnce : this.selectedVariant.price) / this.servingsDivisor)} a night</span><span class="b">Free shipping over $75</span></div>
            </div>
          </label>
        </div>
        ${this.subscriptionFirst ? html`
        <div class="skio-v2-ctalinks">
          ${!this.hideQuizLink ? html`<a href="/pages/sleep-quiz">Not sure? Take our sleep quiz</a>` : ''}
          <a href="#" class="skio-v2-howsubs" aria-haspopup="dialog" aria-expanded="false" @click=${(e) => {
      e.preventDefault();
      // Informational only — does not touch plan selection or cart. Bubbles +
      // composed so it crosses the shadow boundary to the PDP drawer listener.
      e.currentTarget.dispatchEvent(new CustomEvent('slp:open-subscription-drawer', { bubbles: true, composed: true }));
    }}>How Subscriptions Work?</a>
        </div>
        ` : html``}
        ${this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) => {
      const v2plan = group.selected_selling_plan;
      const v2disc = this.discount(v2plan);
      const v2hasDiscount = v2disc.percent !== '0%';
      // Off today (per order) = one-time price - subscribe price = the discount amount (cents).
      const v2saveToday = this.money(v2disc.amount).replaceAll(".00", "");
      // Annual savings = per-order savings x deliveries/year, from the SELECTED plan's interval.
      const v2perYear = this.money(v2disc.amount * this.deliveriesPerYear(v2plan)).replaceAll(".00", "");
      // Per-night = single-bottle subscribe price / servings-per-container (independent of frequency).
      const v2unitPrice = this.price(v2plan, false) / this.unitsPerDelivery(v2plan);
      const v2perNightMoney = this.money(v2unitPrice / this.servingsDivisor);
      // Offer page (fork): first-order welcome price = plan price minus offer-sub-percent.
      // null when the offer is off -> every branch below falls back to the original markup.
      const v2offer = this.offerSubCents(v2plan);
      const v2offerOn = v2offer !== null;
      const v2listCents = this.selectedVariant.price * this.unitsPerDelivery(v2plan);
      const v2offerPerNight = v2offerOn ? this.money(v2offer / this.unitsPerDelivery(v2plan) / this.servingsDivisor) : '';
      const v2offerSaveToday = v2offerOn ? this.money(v2listCents - v2offer) : '';
      const v2offerBadge = v2offerOn ? this.offerTemplate(this.offerSubBadge, { pct: this.offerPctOffList(v2offer, v2listCents) }) : '';
      const v2offerThen = v2offerOn ? this.offerTemplate(this.offerSubThen, { price: this.money(this.price(v2plan, false)), pct: String(v2disc.percent).replace('%', '') }) : '';
      return html`
            <div class="skio-group-container skio-group-container--available skio-v2-group ${this.selectedSellingPlanGroup == group ? 'skio-group-container--selected' : ''}" skio-group-container
              aria-expanded="${this.selectedSellingPlanGroup == group ? 'true' : 'false'}"
              @click=${() => this.selectSellingPlanGroup(group)}>
              <input id="skio-selling-plan-group-${index}-${this.key}" class="skio-group-input" name="skio-group-${this.key}"
                type="radio" value="${group.id}" skio-selling-plan-group="${group.id}" ?checked=${this.selectedSellingPlanGroup == group ? true : false} >
              <label class="skio-group-label" for="skio-selling-plan-group-${index}-${this.key}">
                <div class="skio-v2-head">
                  <div class="skio-v2-titlewrap">
                    <span class="skio-v2-radio"></span>
                    <span class="skio-group-title skio-v2-title">Subscribe &amp; Save</span>
                  </div>
                  <div class="skio-v2-headright">
                    <div class="skio-price skio-v2-price">
                      ${v2offerOn ? html`<del>${this.money(v2listCents)}</del>` : v2hasDiscount ? html`<del>${this.moneyFormatter.format(this.selectedVariant.price / 100).replaceAll(".00", "")}</del>` : html``}
                      <span skio-subscription-price>${v2offerOn ? this.money(v2offer) : this.price(group.selected_selling_plan)}</span>
                    </div>
                  </div>
                </div>

                <div class="skio-v2-tags">
                  <span class="skio-v2-tag-best">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                    Most Popular
                  </span>
                  ${v2offerOn ? html`<span class="skio-v2-tag-save skio-v2-tag-offer">${v2offerBadge}</span>` : v2hasDiscount ? html`<span class="skio-v2-tag-save">Save ${v2disc.percent}</span>` : html``}
                </div>

                <div class="skio-v2-hero">Just ${v2offerOn ? v2offerPerNight : v2perNightMoney} a night</div>

                ${v2offerOn ? html`
                <div class="skio-v2-savings"><span class="s1">You save </span><span class="s2">${v2offerSaveToday} today</span><span class="s-sep"> · </span><span class="s2">${v2perYear} a year after</span></div>
                ` : v2hasDiscount ? html`
                <div class="skio-v2-savings"><span class="s1">You save </span><span class="s2">${v2perYear} a year</span></div>
                ` : html``}

                <div class="skio-v2-hint">Tap to choose the subscription and unlock all benefits &uarr;</div>

                <div class="skio-v2-detailwrap">
                <div class="skio-v2-detail" aria-hidden="${this.selectedSellingPlanGroup == group ? 'false' : 'true'}" ?inert=${this.selectedSellingPlanGroup != group}>
                <div class="skio-v2-divider"></div>

                <div class="skio-v2-freq-label">How often do you need it?</div>
                <div class="skio-v2-freq-field">
                  <select skio-selling-plans="${group.id}" class="skio-frequency skio-v2-select${group.selling_plans.length == 1 ? ' skio-frequency--one' : ''}"
                    @change=${(e) => this.selectSellingPlan(e.target, group)}
                  >
                    ${group ? group.selling_plans.map((selling_plan) =>
        html`
                      <option value="${selling_plan.id}" ?selected=${group.selected_selling_plan == selling_plan}>${selling_plan.name}</option>
                        `
      ) : ''}
                  </select>
                  <svg class="skio-v2-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </div>

                <div class="skio-v2-benefits">
                  <ul>
                    <li>
                      <svg class="skio-v2-bicon" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="5" width="4" height="14" rx="1"></rect><rect x="14" y="5" width="4" height="14" rx="1"></rect></svg>
                      <span><b>Pause, skip, or cancel anytime</b></span>
                    </li>
                    <li>
                      <svg class="skio-v2-bicon" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                      <span>${v2offerOn ? v2offerThen : html`Save ${v2disc.percent} for life`}</span>
                    </li>
                    <li>
                      <svg class="skio-v2-bicon" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"></path></svg>
                      <span>Free gifts</span>
                    </li>
                    <li>
                      <svg class="skio-v2-bicon" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                      <span>2x loyalty rewards</span>
                    </li>
                  </ul>
                </div>

                <div class="skio-v2-ship">
                  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h1"></path><path d="M14 9h4l4 4v4a1 1 0 0 1-1 1h-1"></path><circle cx="7.5" cy="18.5" r="2"></circle><circle cx="17.5" cy="18.5" r="2"></circle></svg>
                  <span><b>Free shipping, always.</b> <span class="skio-v2-ship-amt">Save $5.95 on every order</span></span>
                </div>
                </div><!-- /.skio-v2-detail -->
                </div><!-- /.skio-v2-detailwrap -->
              </label>
            </div>
          `;
    }) : ''}

            <!-- <details class="skio-details" @mouseover=${(e) => this.detailsMouseover()} @mouseleave=${(e) => this.detailsMouseleave()}>
              <summary>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowRepeat"><path d="M18 2l3 3-3 3"/><path d="M6 22l-3-3 3-3"/><path d="M21 5H10a7 7 0 0 0-7 7"/><path d="M3 19h11a7 7 0 0 0 7-7"/></svg>
                
                  How do subscriptions work?
                </span>
              </summary>
              <div class="skio-details--content">
                <ul>
                  <li>
                    <div class="skio-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <div class="skio-content">
                      <p>Get exclusive deals</p>
                      <small>Subscribe for unique discounts</small>
                    </div>
                  </li>
                  <li>
                    <div class="skio-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                      </svg>
                    </div>
                    <div class="skio-content">
                      <p>Edit your subscription anytime</p>
                      <small>Edit products, delivery schedule and more</small>
                    </div>
                  </li>
                  <li>
                    <div class="skio-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                      </svg>
                    </div>
                    
                    <div class="skio-content">
                      <p>No commitment</p>
                      <small>Easy to cancel if it’s not for you</small>
                    </div>
                  </li>
                </ul>
                <div class="skio-details--footer">
                  <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a> 
                  
                  <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover" target="_blank" rel="noopener">
                    Powered by
                    <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z" fill="black"/>
                      <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="black"/>
                      <path d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z" fill="black"/>
                      <path d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z" fill="black"/>
                    </svg>
                  </a>
                  
                </div>
              </div>
            </details> -->

            ${this.showAddToCartButton ? html`
              <button @click=${() => this.addToCart()} class="add-to-cart">Add to Cart</button>
            ` : html``}

      </fieldset>`
  }

  updated = (changed) => { //console.log('Hemangi');
    // Hide the theme's price block when it exists. Guard against a missing
    // element: templates that show the price only via this picker (e.g. the
    // Deep Zzzs formula-switcher PDP) render no .product-info__price element,
    // and an unguarded null deref here threw before the selling-plan-group
    // population below ran, leaving render() with 0 groups so the whole picker
    // rendered empty/invisible. No behaviour change where the element exists.
    const externalPriceEl = document.querySelector('.product-info__price');
    if (externalPriceEl) externalPriceEl.style.visibility = 'hidden';
    if (changed.has('product') && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort(function (a, b) {
          if (parseInt(a.name.replace(/\D/g, "")) < parseInt(b.name.replace(/\D/g, ""))) return -1;
          if (parseInt(a.name.replace(/\D/g, "")) > parseInt(b.name.replace(/\D/g, ""))) return 1;
          if (parseInt(a.name.replace(/\D/g, "")) == parseInt(b.name.replace(/\D/g, ""))) return 0;
        })
      });

    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      let skioSellingPlanGroups = JSON.parse(JSON.stringify(this.skioSellingPlanGroups));
      this.availableSellingPlanGroups = skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan

        this.availableSellingPlanGroups.forEach((group) => {
          group.selling_plans = group.selling_plans.filter(x => this.selectedVariant.selling_plan_allocations.find(y => y.selling_plan_id == x.id));
        })

        this.availableSellingPlanGroups.forEach((group => {
          if (this.defaultFrequency) {
            let selling_plan = group.selling_plans.find(x => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));
            if (selling_plan) group.selected_selling_plan = selling_plan;
            else group.selected_selling_plan = group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
        }));

        if (this.startSubscription == true || this.product.requires_selling_plan == true || this.purchaseOption == 'subscription') {
          //find a matching selling plan, or choose first available

          if (this.selectedSellingPlan == null || this.selectedSellingPlan == undefined) {
            this.selectSellingPlanGroup(this.availableSellingPlanGroups[0]);
          }

          let sellingPlanName = this.selectedSellingPlan?.name;

          let sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.selling_plans.find(y => y.name == sellingPlanName));
          let sellingPlan = sellingPlanGroup?.selling_plans.find(y => y.name == sellingPlanName);
          if (sellingPlanName == sellingPlan.name) {
            this.selectedSellingPlanGroup = sellingPlanGroup;
            this.selectedSellingPlan = sellingPlan;
          } else {
            this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
            this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
          }

        } else {
          this.selectedSellingPlan, this.selectedSellingPlanGroup = null
        }
      } else {
        this.selectedSellingPlan, this.selectedSellingPlanGroup = null
      }

      //update the form that was passed, if any
      this.updateForm();

    }

    if (changed.has('selectedSellingPlan')) {
      //update price of price elements if applicable
      document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${this.key}"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-subscription-content][skio-key="${this.key}"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      //Offer page (fork): also carry the computed welcome prices (cents, or null when off)
      //so dz-offer-formula-script / the auto-apply script can read them without re-deriving.
      const offerPrices = this.syncOfferHostAttrs();
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          sellingPlan: this.selectedSellingPlan,
          key: this.key,
          offerOnceCents: offerPrices.once,
          offerSubCents: offerPrices.sub
        }
      });

      this.dispatchEvent(event);

      //update the form that was passed, if any
      this.updateForm();
      this.updateExternalPrice();

      //update the Buy Now button label so its price reflects the SELECTED plan
      //(subscription = discounted price, one-time = full variant price). This only
      //changes the visible label; the submitted variant id + selling_plan are unchanged.
      //Whole-dollar prices drop the trailing .00 ("$45 - Buy Now") to match the
      //box's own price rendering and the PDP Figma standard; cents are kept.
      const skioBuyButton = document.querySelector('[product-buy-button]');
      if (skioBuyButton && !skioBuyButton.disabled && this.selectedVariant) {
        //Offer page (fork): the label shows the welcome price for the selected option,
        //kept WITH cents ("$36.00 - Buy Now") so it matches the card it mirrors.
        const skioOfferAmount = this.offerSelectedCents();
        if (skioOfferAmount !== null) {
          skioBuyButton.innerHTML = this.money(skioOfferAmount) + ' - Buy Now';
        } else {
        const skioButtonAmount = this.selectedSellingPlan
          ? this.price(this.selectedSellingPlan, false)
          : this.selectedVariant.price;
        skioBuyButton.innerHTML = this.money(skioButtonAmount).replaceAll('.00', '') + ' - Buy Now';
        }
      }

      //update external selling_plan input value
      let sellingPlanInput = document.querySelector('input[name="selling_plan"]')
      this.selectedSellingPlan != null ? sellingPlanInput.value = this.selectedSellingPlan.id : sellingPlanInput.value = ''

    }

    if (changed.has('formId')) {
      //update the form that was passed, if any
      this.updateForm();
    }

    //Offer page (fork): a formula switch in Try Once mode changes the variant but
    //not selectedSellingPlan, so the block above does not run. Keep the host
    //data attributes and the Buy Now label on the new variant's welcome price.
    //No-op when both offers are off.
    if (changed.has('selectedVariant') && !changed.has('selectedSellingPlan') && this.selectedVariant && this.offerActive()) {
      this.syncOfferHostAttrs();
      const offerBuyButton = document.querySelector('[product-buy-button]');
      const offerAmount = this.offerSelectedCents();
      if (offerBuyButton && !offerBuyButton.disabled && offerAmount !== null) {
        offerBuyButton.innerHTML = this.money(offerAmount) + ' - Buy Now';
      }
    }

  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) => {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  detailsMouseover() {
    let details = this.renderRoot.querySelector('.skio-details');
    let summary = this.renderRoot.querySelector('.skio-details summary');
    if (!details.hasAttribute('open') && this.showDetailsHover == false) {
      summary.click();
      this.showDetailsHover = true;
    }
  }

  detailsMouseleave() {
    let details = this.renderRoot.querySelector('.skio-details');
    let summary = this.renderRoot.querySelector('.skio-details summary');
    if (details.hasAttribute('open') && this.showDetailsHover == true) {
      summary.click();
      this.showDetailsHover = false;
    }
  }

  updatePriceElement() {
    let priceEl = document.querySelector(`[data-skio-price="${this.product.id}"]`);
    if (priceEl) {
      //add formatted price here
      let high = 0;
      this.product.variants.forEach((variant) => {
        if (variant.price > high) high = variant.price;
      });
      let content = '';
      if (!this.selectedSellingPlan) {
        content = this.moneyFormatter.format(this.selectedVariant.price / 100).replaceAll('A', '');
      } else {
        content = `<del>${this.moneyFormatter.format(high / 100).replaceAll('A', '')}</del>${this.price(this.selectedSellingPlan).replaceAll('A', '')}`;
      }
      priceEl.innerHTML = content;
    }
  }

  getMetadata(field) {
    let meta = this.meta;
    if (meta !== {}) {
      let fieldData = meta[field];
      if (fieldData) return fieldData;
      else return '';
    }
  }

  getVariantMetadata(variantId, field) {
    let meta = this.meta;
    if (meta !== {}) {
      let variantData = meta[variantId];
      if (variantData) {
        let fieldData = variantData[field];
        if (fieldData) return fieldData;
        else return '';
      }
    }
  }

  servingPriceOnetime() {
    return this.money(this.servingPrice * 100) + ' per serving';
  }

  servingPriceSubscribe(group) {
    let discount = this.discount(group.selected_selling_plan);
    let decimal = (this.selectedVariant.price - discount.amount) / this.selectedVariant.price;
    return this.money((this.servingPrice * 100) * decimal) + ' per serving';
  }

  updateExternalPrice() {
    //Same trailing-.00 strip as the direct label writer above — keeps the Buy
    //button's whole-dollar prices in the "$45" standard format on every path.
    //Offer page (fork): when a welcome price applies it is written (with cents)
    //to the external price element and the Buy Now label instead.
    const offerAmount = this.offerSelectedCents();
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      if (offerAmount !== null) {
        el.innerHTML = this.money(offerAmount);
        document.querySelector('[product-buy-button]').innerHTML = el.innerHTML + ' - Buy Now';
        return;
      }
      this.selectedSellingPlan ? el.innerHTML = this.price(this.selectedSellingPlan) : el.innerHTML = this.money(this.selectedVariant.price);
      document.querySelector('[product-buy-button]').innerHTML = el.innerHTML.replaceAll('.00', '') + ' - Buy Now';
    })
    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      if (offerAmount !== null) {
        el.innerHTML = this.money(offerAmount) + ' ' + this.currency;
        document.querySelector('[product-buy-button]').innerHTML = el.innerHTML + ' - Buy Now';
        return;
      }
      this.selectedSellingPlan ? el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency : el.innerHTML = this.money(this.selectedVariant.price) + ' ' + this.currency;
      document.querySelector('[product-buy-button]').innerHTML = el.innerHTML.replaceAll('.00', '') + ' - Buy Now';
    })
  }

  // ===== Offer page (fork) — display-only welcome-offer helpers =====
  // Every helper returns null / false when the matching offer-* percent is
  // absent or 0, so the original code paths run untouched on non-offer pages.

  offerPercent(value) {
    const n = Number(value);
    return (isFinite(n) && n > 0 && n < 100) ? n : 0;
  }

  offerActive() {
    return this.offerPercent(this.offerOnetimePercent) > 0 || this.offerPercent(this.offerSubPercent) > 0;
  }

  // Try Once welcome price: list price minus offer-onetime-percent (integer cents).
  offerOnceCents() {
    const pct = this.offerPercent(this.offerOnetimePercent);
    if (!pct || !this.selectedVariant) return null;
    return Math.round(this.selectedVariant.price * (100 - pct) / 100);
  }

  // Subscribe first-order welcome price: the selling plan's own price (list minus
  // the plan discount, e.g. 25%) minus offer-sub-percent (integer cents).
  offerSubCents(selling_plan) {
    const pct = this.offerPercent(this.offerSubPercent);
    if (!pct || !selling_plan || !this.selectedVariant) return null;
    return Math.round(this.price(selling_plan, false) * (100 - pct) / 100);
  }

  // Welcome price for whatever is selected right now (Subscribe -> sub offer,
  // Try Once -> one-time offer), or null when that option has no offer.
  offerSelectedCents() {
    return this.selectedSellingPlan ? this.offerSubCents(this.selectedSellingPlan) : this.offerOnceCents();
  }

  // Effective "% off list" for the badge: round(100 - firstOrder / list * 100).
  offerPctOffList(firstOrderCents, listCents) {
    const list = listCents || (this.selectedVariant ? this.selectedVariant.price : 0);
    if (!list) return 0;
    return Math.round(100 - (firstOrderCents / list) * 100);
  }

  // Tiny {token} substitution for the admin-editable badge / "Then …" strings.
  offerTemplate(template, vars) {
    return String(template == null ? '' : template).replace(/\{(\w+)\}/g, (match, key) =>
      Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : match
    );
  }

  // Mirror the computed welcome prices onto the host element so Liquid-side
  // scripts can read them without touching the shadow DOM. Attributes are
  // removed (not written as "null") when the matching offer is off.
  syncOfferHostAttrs() {
    const subPlan = this.selectedSellingPlan
      || (this.availableSellingPlanGroups && this.availableSellingPlanGroups[0] && this.availableSellingPlanGroups[0].selected_selling_plan)
      || null;
    const once = this.offerOnceCents();
    const sub = this.offerSubCents(subPlan);
    if (once !== null) this.setAttribute('data-dz-offer-once-cents', String(once));
    else if (this.hasAttribute('data-dz-offer-once-cents')) this.removeAttribute('data-dz-offer-once-cents');
    if (sub !== null) this.setAttribute('data-dz-offer-sub-cents', String(sub));
    else if (this.hasAttribute('data-dz-offer-sub-cents')) this.removeAttribute('data-dz-offer-sub-cents');
    return { once, sub };
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    if (this.selectedSellingPlan) this.lastSellingPlanName = this.selectedSellingPlan.name;
    if (group) this.purchaseOption = 'subscription'
    else this.purchaseOption = 'onetime'

    //update the form that was passed, if any
    this.updateForm();
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find(x => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
      this.lastSellingPlanName = this.selectedSellingPlan.name;
    }
    else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlanButton(plan, group) {
    let selling_plan = group.selling_plans.find(x => x.id == plan.id);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
      this.lastSellingPlanName = this.selectedSellingPlan.name;
    }
    else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Servings/doses per container used for the per-night math. Set via the
  // `servings-per-container` attribute (a theme setting). Falls back to 30 when
  // the attribute is missing, blank, or non-positive so the math never breaks.
  get servingsDivisor() {
    const n = Number(this.servingsPerContainer);
    return (isFinite(n) && n > 0) ? n : 30;
  }

  // Bottles shipped per delivery. Prepaid plans bundle multiple bottles (e.g. a
  // "3 month prepaid"); everything else is 1. Keeps per-night a single-bottle figure.
  unitsPerDelivery(selling_plan) {
    if (selling_plan && selling_plan.name && selling_plan.name.toLowerCase().includes('prepaid') && selling_plan.options && selling_plan.options[0]) {
      const m = String(selling_plan.options[0].value).match(/\d+/g);
      if (m) { const n = parseInt(m.join('')); if (n > 0) return n; }
    }
    return 1;
  }

  // Days between deliveries for the given plan. Prefers structured interval data
  // if the platform exposes it (unit + count), else parses the frequency label
  // ("Every 30 Days" -> 30, "Every 2 Months" -> 60). day=1, week=7, month=30, year=365.
  intervalDaysForPlan(selling_plan) {
    const unitDays = { day: 1, days: 1, week: 7, weeks: 7, month: 30, months: 30, year: 365, years: 365 };
    const dp = selling_plan && (selling_plan.delivery_policy || selling_plan.deliveryPolicy);
    if (dp) {
      const u = String(dp.interval || dp.interval_unit || '').toLowerCase();
      const c = parseInt(dp.interval_count != null ? dp.interval_count : dp.intervalCount) || 1;
      if (unitDays[u]) return unitDays[u] * c;
    }
    const label = String((selling_plan && selling_plan.options && selling_plan.options[0] && selling_plan.options[0].value) || (selling_plan && selling_plan.name) || '').toLowerCase();
    const num = label.match(/\d+/);
    const count = num ? parseInt(num[0]) : 1;
    if (/week/.test(label)) return count * 7;
    if (/month/.test(label)) return count * 30;
    if (/year/.test(label)) return count * 365;
    if (/day/.test(label)) return count > 0 ? count : 30;
    return count > 0 ? count : 30;
  }

  // Deliveries per year implied by the selected plan's interval (minimum 1).
  deliveriesPerYear(selling_plan) {
    const days = this.intervalDaysForPlan(selling_plan);
    return Math.max(1, Math.round(365 / days));
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {

    if (!selling_plan)
      return { percent: '0%', amount: 0 }

    if (selling_plan.name.includes('prepaid')) {

      let option = selling_plan.options[0]['value'];

      var numberPattern = /\d+/g;
      let result = parseInt(option.match(numberPattern).join(''));

      const price_adjustment = selling_plan.price_adjustments[0]
      const discount = { percent: '0%', amount: 0 }
      const price = this.selectedVariant.price * result;

      switch (price_adjustment.value_type) {
        case 'percentage':
          discount.percent = `${price_adjustment.value}%`
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          )
          break
        case 'fixed_amount':
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
        case 'price':
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) /
              price) *
            100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
      }

      return discount

    } else {

      const price_adjustment = selling_plan.price_adjustments[0]
      const discount = { percent: '0%', amount: 0 }
      const price = this.selectedVariant.price;

      switch (price_adjustment.value_type) {
        case 'percentage':
          discount.percent = `${price_adjustment.value}%`
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          )
          break
        case 'fixed_amount':
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`
          discount.amount = price_adjustment.value
          break
        case 'price':
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) /
              price) *
            100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
      }

      return discount

    }

  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {

    if (selling_plan.name.includes('prepaid')) {

      let option = selling_plan.options[0]['value'];
      var numberPattern = /\d+/g;
      let result = parseInt(option.match(numberPattern).join(''));

      return formatted
        ? this.money((this.selectedVariant.price * result) - this.discount(selling_plan).amount).replaceAll(".00", "")
        : (this.selectedVariant.price * result) - this.discount(selling_plan).amount

    } else {

      return formatted
        ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount).replaceAll(".00", "")
        : this.selectedVariant.price - this.discount(selling_plan).amount

    }


  }

  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          selling_plan_input = document.createElement('input');
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(selling_plan_input);
        }

        let discountValue = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
        if (discountValue == '0%') discountValue = null;
        if (discountValue !== null && this.discountFormat !== 'percent') discountValue = this.money(this.discount(this.selectedSellingPlan).amount);

        let discount_input = form.querySelector('[name="properties[Discount]"]');
        if (discount_input) {
          discount_input.value = discountValue;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          if (discountValue == null) discount_input.disabled = true;
        } else {
          discount_input = document.createElement('input');
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value = discountValue;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          if (discountValue == null) discount_input.disabled = true;
          form.append(discount_input);
        }

      } else {
        console.log(`Skio error: form ID is ${this.formId}, but no form with that ID was found.`);
      }
    }
  }

  addVariantClickEventListeners() {
    let variantInputs = document.querySelectorAll(this.variantInputSelector)
    let skio = this
    for (let el of variantInputs) {
      el.addEventListener('click', function (e) {
        // may need to replace with ID / e.target depending on client setup
        // may need to use different attribute depending on ^^
        let variantTitle = e.currentTarget.value
        skio.selectedVariant = skio.product.variants.find(variant => variant.title == variantTitle)
      })
    }
  }

  // Optional functions keep if necessary 

  /**
   *   
   * 
   */

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity = 1) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then((response) => response.json())
      .then((response) => {
        this.log("SKIO added item to cart: ", response);
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key
          }
        });

        this.dispatchEvent(event);
      })
      .catch((error) => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error);
      });
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product;
        this.selectedVariant = product.variants[0];

        return product;
      });
  }
}

if (!customElements.get('skio-plan-picker-v2')) {
  customElements.define('skio-plan-picker-v2', SkioPlanPickerComponent);
}
// v2 fork trigger
